import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1)
const _hoisted_2 = [
  _hoisted_1
]


export default /*#__PURE__*/_defineComponent({
  __name: 'SpinnerComponent',
  props: {
  color: {
    type: String,
    default: "text-white",
  },
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`animate-spin inline-block w-4 h-4 border-[2px] border-current border-t-transparent ${__props.color} rounded-full dark:text-blue-600`),
    role: "status",
    "aria-label": "loading"
  }, _hoisted_2, 2))
}
}

})